module.exports = __webpack_public_path__ + "img/cards_icon.5790a8e1.svg";